import type { AllegroResponsibleProducer } from '../../../api/allegro/responsibleproducer/responsibleProducerTypes';
import type { ExcelRow } from '../../excel/types';
import { serializeExcel } from '../../excel/serializeExcel';
import { XLSX_MIME_TYPE } from '../../excel/constants';
import { downloadData } from '../../../utils/downloadData';
import COLUMNS from './responsibleProducerExcelSchema';

const SHEET_NAME = 'Responsible producers';
const DEFAULT_FILE_NAME = 'responsible-producers.xlsx';

function mapExcelRow(producer: AllegroResponsibleProducer): ExcelRow {
  return {
    [COLUMNS.id]: producer.id,
    [COLUMNS.label]: producer.name,
    [COLUMNS.tradeName]: producer.producerData.tradeName,
    [COLUMNS.countryCode]: producer.producerData.address.countryCode,
    [COLUMNS.street]: producer.producerData.address.street,
    [COLUMNS.postalCode]: producer.producerData.address.postalCode,
    [COLUMNS.city]: producer.producerData.address.city,
    [COLUMNS.email]: producer.producerData.contact.email ?? undefined,
    [COLUMNS.phoneNumber]: producer.producerData.contact.phoneNumber ?? undefined,
    [COLUMNS.formUrl]: producer.producerData.contact.formUrl ?? undefined,
  };
}

export default async function downloadResponsibleProducersExcel(
  producers: AllegroResponsibleProducer[],
  fileName: string = DEFAULT_FILE_NAME,
): Promise<void> {
  const rows = producers.map(mapExcelRow);
  const blob = await serializeExcel(rows, {
    sheetName: SHEET_NAME,
    headers: Object.values(COLUMNS),
  });

  downloadData(blob, XLSX_MIME_TYPE, fileName);
}
